<template>
  <div>

    <v-container>
        <!-- <h3 class="headline mb-3">{{ titulo }} Movimento de Estoque</h3> -->

        <v-card class="mb-3">
          <v-card-title>
            Dados do Pedido
          </v-card-title>
          <v-divider></v-divider>

          <v-container grid-list-md>

            <v-layout row wrap>
              <v-flex sm2 class="py-0">
                <v-text-field label="Número" v-model="movimento.id" disabled></v-text-field>
              </v-flex>
              <v-flex sm2 class="py-0">
                <!-- <v-text-field label="Data" v-model="movimento.data" append-icon="event"></v-text-field> -->
                <z-date-picker-menu label="Data" v-model="movimento.data" :disabled="$route.name == 'PedidosEditar'"></z-date-picker-menu>
              </v-flex>
              <v-flex sm6 class="py-0">
                <v-autocomplete v-model="movimento.fornecedor_id" label="Fornecedor" flat :items="$store.getters['listas/fornecedores']"></v-autocomplete>
              </v-flex>
              <v-flex sm2 class="py-0">
                <v-select v-model="movimento.movimento" label="Movimento" flat :items="['Entrada', 'Saída']"></v-select>
              </v-flex>
            </v-layout>
          </v-container>

        </v-card>

        <v-card class="mb-3">
          <v-toolbar flat color="white" height="56">
            <h3 class="body-1" style="margin-left: -10px">Adicionar Produto</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-container grid-list-md class="pt-1">
            <v-layout row wrap>
              <v-flex sm2>
                <v-text-field v-model="produto.referencia" append-icon="search" @click:append="buscarProduto" :loading="buscando" ref="referencia" placeholder="Referência" hide-details @keyup.enter="buscarProdutoPorReferencia" @keyup.esc="onKeyUpEscAdicionarProduto" :disabled="buscando"></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-text-field v-model="produto.descricao" ref="descricao" placeholder="Descrição" hide-details :disabled="buscando" readonly></v-text-field>
              </v-flex>
              <v-flex sm2>
                <z-campo-valor v-model="produto.quantidade" :suffix="produto.unidade" ref="quantidade" placeholder="Quantidade" :decimais="0" hide-details @keyup.enter="$refs.valor.focus()" @keyup.esc="onKeyUpEscAdicionarProduto" @input="calcularSubTotal" :disabled="buscando || !produto.descricao"></z-campo-valor>
              </v-flex>
              <v-flex sm2>
                <z-campo-valor v-model="produto.valor" ref="valor" placeholder="Valor" hide-details @keyup.enter="adicionarProduto" @keyup.esc="onKeyUpEscAdicionarProduto" @input="calcularSubTotal" :disabled="buscando || !produto.descricao"></z-campo-valor>
              </v-flex>
              <v-flex sm2>
                <z-campo-valor v-model="produto.subtotal" ref="subtotal" placeholder="SubTotal" hide-details readonly :disabled="buscando || !produto.descricao"></z-campo-valor>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-card class="mb-3">
          <v-toolbar flat color="white" height="56">
            <h3 class="body-1" style="margin-left: -10px">Produtos</h3>
          </v-toolbar>
          <v-divider></v-divider>

          <v-data-table :headers="headers" :items="produtos" hide-default-footer item-key="id" :loading="false">
            <template v-slot:item="props">
                <td>{{ props.item.referencia }}</td>
                <td>{{ props.item.descricao }}</td>
                <td class="text-right">{{ props.item.quantidade}} {{ props.item.unidade }}</td>
                <td class="text-right">{{ props.item.valor | valorBR }}</td>
                <td class="text-right">{{ props.item.subtotal | valorBR }}</td>
                <td class="text-center">
                  <v-btn icon @click="excluirProduto(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
            </template>
            <template slot="footer" >
              <td></td>
              <td></td>
              <td class="text-right"><b>{{ movimento.quantidade_total }}</b></td>
              <td></td>
              <td class="text-right"><b>{{ movimento.valor_total | valorBR }}</b></td>
              <td></td>
            </template>
          </v-data-table>
        </v-card>

        <v-card class="mb-3">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex sm2 offset-sm6 class="py-0">
                <z-campo-valor decimais="0" label="Itens" v-model="movimento.itens" readonly></z-campo-valor>
              </v-flex>
              <v-flex sm2 class="py-0">
                <z-campo-valor label="Quantidade" v-model="movimento.quantidade_total" readonly></z-campo-valor>
              </v-flex>
              <v-flex sm2 class="py-0">
                <z-campo-valor label="Valor Total" v-model="movimento.valor_total" readonly></z-campo-valor>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex sm12 class="py-0">
                <v-textarea label="Observações" v-model="movimento.observacoes" placeholder="Observações sobre o movimento"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text  @click="$router.push('/financeiro/contasareceber')" :disabled="salvando">Voltar</v-btn>
            <v-btn color="primary" @click="confirmar" :loading="salvando">Salvar</v-btn>
          </v-card-actions>
        </v-card>

    </v-container>

    <busca-produto ref="buscaproduto" @selecionar:produto="selecionarProduto"></busca-produto>

  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import BuscaProduto from '@/pages/pedidos/BuscaProduto';
export default {
    name: 'estoque-form',

    components: {
      BuscaProduto
    },

    data() {
        return {

        };
    },

    // beforeRouteLeave(to, from, next) {
    //     this.UNSET_MOVIMENTO();
    //     next();
    // },

    async mounted() {
      this.setTitulo(this.titulo);
      this.$store.dispatch('listas/fornecedores');
    },

    methods: {
      ...mapMutations(['setTitulo', 'LOADING_OFF']),

    },

    computed: {
      config() {
        return this.$store.state.configuracoes;
      },

      titulo() {
        let titulo = this.$route.meta.editando ? 'Editar' : 'Adicionar';
        return titulo + ' ' + 'Contas a Receber';
      }
    },
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */

  .trasparente >>> .v-input__slot {
    background: none;
  }

</style>
